import configureStore from "../../../store/configureStore";

import { uiStopLoading } from "../../../store/actions";

export default function dbGetRecords(
  targetTable,
  idToken,
  criteria,
  isCustomPath,
  fieldsArray
) {
  return dispatch => {
    //let fetchQuery = "https://brooklynzdev.firebaseio.com/";
    const state = configureStore.getState();

    let fbDbUrl = state.db.team.fbDbUrl;
    let fbCloudUrl = state.db.team.fbCloudUrl;
    let fetchQuery = "";
    if (isCustomPath === true) {
      //console.log(targetTable+' this is custom path')
      fetchQuery = fbCloudUrl + "/" + targetTable;
    } else {
      //console.log(targetTable+' this is NOT custom path')
      fetchQuery = fbCloudUrl + "/getRecordsLight";
    }
    //console.log("Fetching records, "+targetTable+", criteria :"+JSON.stringify(criteria)+" fetchURL: "+fetchQuery);
    //fetchQuery= fetchQuery+targetTable+".json?";
    let requestBody = {};
    if (isCustomPath === true) {
      requestBody = criteria;
    } else {
      if (criteria === undefined) {
        requestBody = {
          path: targetTable
        };
      } else {
        if (fieldsArray && fieldsArray !== undefined) {
          requestBody = {
            path: targetTable,
            criteria: criteria,
            requiredFields: fieldsArray
          };
        } else {
          requestBody = {
            path: targetTable,
            criteria: criteria
          };
        }
      }
    }

    //logger("DEBUG","dbGetRecords("+targetTable+")", ">>request: "+JSON.stringify(requestBody));

    return fetch(fetchQuery, {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: {
        authorization: "Bearer " + idToken
      }
    })
      .then(res => res.json())
      .then(parsedRes => {
        //logger("DEBUG","dbGetRecords("+targetTable+")", "Fetching all "+targetTable+"  successful");
        //logger("DEBUG","dbGetRecords("+targetTable+")", "Results: " + JSON.stringify(parsedRes));
        return parsedRes;
      })
      .catch(err => {
        //logger("BASIC","dbGetRecords("+targetTable+")"+ "Fetch projects from db failed "+err);
        dispatch(uiStopLoading());
        alert(
          "[RECS] dbGetRecords(" +
            targetTable +
            "). We are unable to complete your request at this time, please check your network connection or contact support[getRecord][" +
            err +
            "]"
        );
        //console.log("[RECS]We are unable to complete your request at this time, please check your network connection or contact support[getRecord]["+err+"]");
      });
  };
}



// WEBPACK FOOTER //
// ./src/Services/Firebase/Generic/dbGetRecords.js